module.exports = __webpack_public_path__ + "img/betflix-support.fc0a43e0.png";